import { createSlice } from '@reduxjs/toolkit';

import { MODAL_KEYS } from '_constants/modals';

const initialState = {
  visibility: {
    [MODAL_KEYS.appointmentScheduling]: false,
    [MODAL_KEYS.xeroAuthConfirm]: false,
    [MODAL_KEYS.documentUpload]: false,
    [MODAL_KEYS.paymentMethodAdd]: false,
    [MODAL_KEYS.statementDelete]: false,
    [MODAL_KEYS.transactionAdd]: false,
    [MODAL_KEYS.transactionUpdate]: false,
    [MODAL_KEYS.transactionDelete]: false,
    [MODAL_KEYS.taskResponseSend]: false,
    [MODAL_KEYS.bankAccountDelete]: false,
    [MODAL_KEYS.chatMessageSearch]: false,
  },
  data: {
    [MODAL_KEYS.appointmentScheduling]: {},
    [MODAL_KEYS.xeroAuthConfirm]: {},
    [MODAL_KEYS.documentUpload]: {},
    [MODAL_KEYS.paymentMethodAdd]: {},
    [MODAL_KEYS.statementDelete]: {},
    [MODAL_KEYS.transactionAdd]: {},
    [MODAL_KEYS.transactionUpdate]: {},
    [MODAL_KEYS.transactionDelete]: {},
    [MODAL_KEYS.taskResponseSend]: {},
    [MODAL_KEYS.bankAccountDelete]: {},
    [MODAL_KEYS.chatMessageSearch]: {},
  },
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload.key]: true,
      };

      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.data || {},
      };
    },
    hideModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload.key]: false,
      };

      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.data || {},
      };
    },
    resetModals(state) {
      state.visibility = initialState.visibility;
      state.data = initialState.data;
    },
  },
});

export const { showModal, hideModal, resetModals } = modalsSlice.actions;

export default modalsSlice.reducer;
